"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dialogClasses = exports.default = void 0;
exports.getDialogUtilityClass = getDialogUtilityClass;
var _base = require("@ori-ui/mui-bundle/base");
function getDialogUtilityClass(slot) {
  return (0, _base.generateUtilityClass)('MuiOriDialog', slot);
}
const dialogClasses = exports.dialogClasses = (0, _base.generateUtilityClasses)('MuiOriDialog', ['root', 'backButton', 'backdrop', 'closeButton', 'content', 'dialogGrid', 'drawer', 'footer', 'header', 'sizeMedium', 'sizeSmall']);
var _default = exports.default = dialogClasses;
//# sourceMappingURL=dialogClasses.js.map